import React, { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'
import { FieldLabel } from './form/field-label'

export interface TextAreaProps extends ComponentProps<'textarea'> {
  label?: string | React.ReactNode
  error?: string
  textAreaClassName?: string
  rows?: number
}

export const FormTextArea = ({
  label,
  value,
  onChange,
  onFocus,
  maxLength,
  error,
  placeholder,
  required,
  className,
  textAreaClassName,
  rows,
  name,
  ...rest
}: TextAreaProps) => {
  return (
    <label
      className={twMerge('flex flex-col gap-1 text-sm font-medium text-text-primary', className)}
    >
      <FieldLabel label={label} />
      <textarea
        className={twMerge(
          'mt-1 w-full rounded-lg border border-text-secondary/30 px-4 py-2.5 focus:border-brand-primary focus:outline-none',
          textAreaClassName,
        )}
        rows={rows}
        name={name}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        placeholder={placeholder}
        spellCheck={false}
        maxLength={maxLength}
        {...rest}
      />
      {error ? (
        <p className="mt-2 text-sm text-danger" dangerouslySetInnerHTML={{ __html: error }} />
      ) : null}
    </label>
  )
}
